import React, { useState } from 'react';
import { IoChevronDown } from 'react-icons/io5'; // Icon for toggle
import styles from './CoverageComponent.module.scss';

export interface CoverageComponentProps {
	title: string;
	icon: React.ReactNode; // Icon component (e.g., checkmark or cross)
	items: { title: string; desc?: string }[]; // Array for accordions
}

const CoverageComponent: React.FC<CoverageComponentProps> = ({ title, icon, items }) => {
	const [activeIndex, setActiveIndex] = useState<number | null>(null);

	const toggleAccordion = (index: number) => {
		setActiveIndex(activeIndex === index ? null : index);
	};

	return (
		<div className={styles.coverageBlock}>
			<h5 className={styles.title}>{title}</h5>
			<div className={styles.accordionContainer}>
				{items.map((item, index) => (
					<div
						key={index}
						className={`${styles.accordionItem} ${activeIndex === index ? styles.expanded : ''}`}
						onClick={() => toggleAccordion(index)}
					>
						<div className={styles.accordionHeader}>
							<span className={styles.icon}>{icon}</span>
							<span className={styles.itemTitle}>{item.title}</span>
							<IoChevronDown
								className={`${styles.toggleIcon} ${activeIndex === index ? styles.rotate : ''}`}
							/>
						</div>
						{activeIndex === index && item.desc && (
							<div className={styles.accordionContent}>
								<p>{item.desc}</p>
							</div>
						)}
					</div>
				))}
			</div>
		</div>
	);
};

export default CoverageComponent;
